import { Component, inject } from "@angular/core";
import { FormsModule } from "@angular/forms";
import { NgSelectModule } from "@ng-select/ng-select";
import { KeyValue } from "@models/generic/KeyValuePair";
import { DevManagementDataService } from "@app/admin/services/devmanagement.service";
import { TranslatePipe, provideTranslationScope } from "@app/shared/i18n/translation-scope";
import { scope } from "@app/admin/i18n/scope";

@Component({
    selector: "dev-export",
    templateUrl: "./dev-export.component.html",
    styleUrls: ["./dev-export.component.scss"],
    imports: [FormsModule, NgSelectModule, TranslatePipe],
    viewProviders: [provideTranslationScope(scope)],
})
export class DevExportComponent {
    private dataService = inject(DevManagementDataService);

    exportTypes: KeyValue<number, string>[];
    selectedExportType: number;

    constructor() {
        this.dataService.getExportTypes().subscribe((x) => {
            this.exportTypes = x;
            this.selectedExportType = x[0].Key;
        });
    }

    public export() {
        this.dataService.export(this.selectedExportType);
    }
}
